const URL_BACKEND = process.env.VUE_APP_URL_BACKEND;
import axios from "@/lib/axioxAppli";
import * as types from "./mutation_types";

export const retrieve = ({ commit }, id) => {
  commit(types.ROB_SHOW_TOGGLE_LOADING);
  axios
    .get(URL_BACKEND + "api-rob/" + id + "/")
    .then((response) => {
      commit(types.ROB_SHOW_TOGGLE_LOADING);
      commit(types.ROB_SHOW_SET_RETRIEVED, response.data);
    })
    .catch((e) => {
      commit(types.ROB_SHOW_TOGGLE_LOADING);
      commit(types.ROB_SHOW_SET_ERROR, e.message);
    });
};

export const reset = ({ commit }) => {
  commit(types.ROB_SHOW_RESET);
};
